import { useEffect, useState } from 'react';
import { appUrl } from '@utils/url';

export const useConfigurations = () => {
  const [configurations, setConfigurations] = useState({ loaded: false });
  useEffect(() => {
    fetch(appUrl('/assets/config.json'))
      .then((response) => response.json())
      .then((data) => setConfigurations({ ...data, loaded: true }))
      .catch(console.error);
  }, []);
  return { configurations };
};
